import { render, staticRenderFns } from "./RecipeCost.vue?vue&type=template&id=98dfe02e&scoped=true"
import script from "./RecipeCost.vue?vue&type=script&lang=js"
export * from "./RecipeCost.vue?vue&type=script&lang=js"
import style0 from "./RecipeCost.vue?vue&type=style&index=0&id=98dfe02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dfe02e",
  null
  
)

export default component.exports